import React from "react";
import classNames from "classnames";
import { type IContentLoaderProps } from "react-content-loader";

import Placeholder, { Rect } from "@/components/Skeleton";

const ButtonPlaceholder: React.FC<
  {
    height?: string;
    width?: string;
    "data-testid"?: string;
  } & IContentLoaderProps
> = ({
  className,
  height = "30",
  width = "100%",
  "data-testid": dataTestId,
  ...props
}) => (
  <Placeholder
    className={classNames(className, "rounded-full")}
    width={width}
    height={height}
    data-testid={dataTestId}
    {...props}
  >
    <Rect y="0" width="100%" height="100%" />
  </Placeholder>
);

export default ButtonPlaceholder;
